/**
 * Athletes Module - Entry point for athlete directory functionality
 */

import { athleteService } from '@services/athletes.js';
import * as utils from '@utils/index.js';

// Export for ES module usage
export { athleteService, utils };

// Export globally for backwards compatibility
window.AthleteService = athleteService;

console.info('Athletes module loaded');
